export default __webpack_public_path__ + "static/media/inspiritai.a2a583d2.png";